import { Field, PageLinkButton, TableCell, TablePage } from '@contember/admin'
import * as React from 'react'
import { EditButton } from '../components'

export const PodcastListPage = (
	<TablePage
		pageName="podcastList"
		entities="Podcast[site.slug = $site]"
		orderBy="publishedAt desc"
		rendererProps={{
			title: 'Podcasts',
			actions: (
				<>
					<PageLinkButton to="podcastCreate">Add a new podcast</PageLinkButton>
				</>
			),
		}}
	>
		<TableCell>
			<Field field="name" />
		</TableCell>
		<TableCell>
			<Field field="subtitle" />
		</TableCell>
		<TableCell>
			<div style={{ color: '#444', fontSize: '11px' }}>
				<Field
					field="publishedAt"
					format={val => {
						return val ? 'Published on ' + new Date(val as string).toLocaleDateString() : 'Not published'
					}}
				/>
			</div>
		</TableCell>
		<TableCell shrunk>
			<EditButton pageName="podcastEdit" />
		</TableCell>
	</TablePage>
)
